import React from 'react'
import './styles.css'
import {connect} from "react-redux";
import * as actionCreator from "../../../../store/Action/index";
import {Button,Card, CardBody, CardHeader, Col, Row} from 'reactstrap';
import LabelInput from "../../../../components/Input/Input/TxtLbl";
import {MDBDataTable} from 'mdbreact'
import {Button as SementicBtn,  Form} from 'semantic-ui-react'
import {Icon, Spin, Tooltip} from "antd";
import * as Validator from "../../../../util/Validator";
import $ from "jquery";
import * as common from "../../../../const/Common/CommonFunc";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import swal from "sweetalert";
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import axiosVisitor from "../../../../axios/axios_visitortag";
import apiConfig from "../../../../axios/axios_api_services";

class App extends React.Component {

  state = {
    wifiData: {
      name:
        {
          value: '',
          valid: false
        },
      code:
        {
          value: '',
          valid: false
        },
      valid: false
    },
    formValid: false,
    updateWifi: false,
    wifiList: [],
    isSpin: false,
    wifiId: 0
  };
  handleChange = (name, length) => event => {
    let value = event.target.value;
    const valid = Validator.textFieldValidator(value, length);

    const formData = {
      ...this.state.wifiData
    };
    formData[name].value = value;
    formData[name].valid = valid;

    this.setState({
      wifiData: formData
    });

    if (formData.name.valid && formData.code.valid) {
      formData.valid = true
    } else {
      formData.valid = false
    }

    this.setState({
      wifiData: formData
    });
  };
  clearFeilds = () => {
    this.setState({
      wifiData: {
        name:
          {
            value: '',
            valid: false
          },
        code:
          {
            value: '',
            valid: false
          },
        valid: false
      },
      formValid: false,
      updateWifi: false,
    })
  };

  updateWifiPackage = () => {
    const obj = {
      "packageId": this.state.wifiId,
      "code": this.state.wifiData.code.value,
      "name": this.state.wifiData.name.value,
      "expireDate": new Date().getTime()
    };
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    this.props.spinnerHandler(true);

    axiosVisitor.post(apiConfig.CORPORATE_WIFI_PACKAGES, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Wifi package details successfully updated - (" + obj.name + ")", 0);
          this.clearFeilds();
          this.getAllWifi();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.updateWifiPackage()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  addWifiPackage = () => {
    const obj = {
      "code": this.state.wifiData.code.value,
      "name": this.state.wifiData.name.value,
      "expireDate": new Date().getTime()
    };
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    this.props.spinnerHandler(true);

    axiosVisitor.put(apiConfig.CORPORATE_SELECT_WIFI_PACKAGES(this.props.usr_obj.corporateId), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Wifi package details successfully created - (" + obj.name + ")", 0);
          this.clearFeilds();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.addWifiPackage()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
        this.getAllWifi()
      });
  };
  changeSpinner = (condition) => {
    this.setState({
      isSpin: condition
    })
  };

  getAllWifi = () => {
    // wifiList
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    this.changeSpinner(true);
    axiosVisitor.get(apiConfig.CORPORATE_SELECT_WIFI_PACKAGES(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            wifiList: response.data.packageList
          })
        } else {
          this.setState({
            wifiList: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllWifi()
        }
      })
      .finally(fin => {
        this.changeSpinner(false);
      });
  };

  addWifi = () => {
    if (!this.state.wifiData.valid) {
      common.warningAlert("Please Fill all required fields")
    } else {

      swal({
        title: this.state.updateWifi ? "Are you sure do you want to update wifi package?" : "Are you sure do you want to add new wifi package?",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Cancel',
          dangerMode: {
            text: "Yes",
            value: "action",
            className: "okay-btn"
          }
        },
      }).then((value) => {

        switch (value) {
          case "action":
            if (this.state.updateWifi) {
              this.updateWifiPackage();
            } else {
              this.addWifiPackage();
            }
            break;
          default:
            break;
        }
      });
    }
  };

  deleteWifi_ = (id) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosVisitor.delete(apiConfig.CORPORATE_WIFI_PACKAGE_SELECT(id), {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Wifi package details successfully deleted", 0);
          this.getAllWifi();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.deleteWifi_(id)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  deleteWifi = (id, name) => {
    swal({
      title: "Do you want to delete this wifi package? First please enter \"" + name + "\"",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      content: "input",
    })
      .then((value) => {
        if (value === name) {
          this.deleteWifi_(id)
        } else {
          common.warningAlert("Can't delete wifi package", 1)
        }
      });
  };
  updateWifi = (obj) => {
    this.setState({
      wifiData: {
        name:
          {
            value: obj.name,
            valid: true
          },
        code:
          {
            value: obj.code,
            valid: true
          },
        valid: true
      },
      wifiId: obj.packageId,
      updateWifi: true
    })
  };

  componentDidMount() {
    $('input').attr('autocomplete', 'off');
    this.getAllWifi()
  }

  render() {
    const rows = [];
    if (this.state.wifiList.length !== 0) {
      this.state.wifiList.map((row, index) => {
        rows.push(
          {
            name: row.name,
            code: row.code,
            action:
              <div>
                <SementicBtn circular icon='edit' onClick={() => this.updateWifi(row)}/>
                <SementicBtn className="cus-btn" circular icon='trash alternate'
                             onClick={() => this.deleteWifi(row.packageId, row.name)}/>
              </div>
          }
        )
      });
    }
    let columns = this.props.table_data.columns;
    let table_data = {columns, rows};

    return (
      <div>
        <Card>
          <CardHeader>Manage Wifi Packages
          </CardHeader>
          <CardBody>
            <Row>
              <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
                <Row>
                  <Col lg={6}>
                    <Form>
                      <Form.Group widths='equal'>
                        <LabelInput
                          required
                          tagText={"Name"}
                          placeholder={"Name"}
                          value={this.state.wifiData.name.value}
                          onChange={this.handleChange('name', 1)}
                        />
                      </Form.Group>

                    </Form>
                  </Col>

                  <Col lg={6}>
                    <Form>
                      <Form.Group widths='equal'>
                        <LabelInput
                          required
                          tagText={"Code"}
                          placeholder={"Code"}
                          value={this.state.wifiData.code.value}
                          onChange={this.handleChange('code', 1)}
                        />
                      </Form.Group>
                    </Form>


                  </Col>
                </Row>

              </Col>

            </Row>
            <center>
              <Button
                className="submit-btn yellow-btn "
                disabled={!this.state.wifiData.valid}
                onClick={this.addWifi}
              >{this.state.updateWifi ? "Update Wifi Package" : "Add Wifi Package"}</Button>
              &nbsp;&nbsp;
              <Tooltip placement="topLeft" title="Clear input fields">
                <SementicBtn circular icon='refresh' onClick={this.clearFeilds}/>
              </Tooltip>
            </center>
          </CardBody>
        </Card>


        <Card>
          <CardHeader>All Wifi Packages</CardHeader>
          <CardBody>
            <Spin spinning={this.state.isSpin} delay={10}
                  indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
              <MDBDataTable
                searching={false}
                displayEntries={false}
                entries={8}
                responsive
                responsiveSm
                responsiveMd
                responsiveLg
                responsiveXl
                bordered
                hover
                data={table_data}/>
            </Spin>
          </CardBody>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  table_data: state.COPAdminReducer.wifiTable_data,
  wifiData: state.COPAdminReducer.wifiData,
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addWifi: (data) => dispatch(actionCreator.addWifi(data)),
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
